import {
  Box,
  Button,
  Divider,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import { useState } from "react";

import { Checkbox, FormControlLabel, FormGroup } from "@mui/material";

import { Chip } from "@mui/material";

import CancelIcon from "@mui/icons-material/Cancel";

const marketingOptions = [
  "Facebook",
  "Instagram",
  "Google Ads",
  "Emails",
  "Referrals",
  "Other",
];

const SafeNumberField = ({ value, onChange, ...props }) => {
  const handle = (e) => {
    const v = e.target.value;

    // only allow digits or empty string
    if (v === "" || /^[0-9]+$/.test(v)) {
      onChange(v);
    }
  };

  return (
    <TextField
      {...props}
      type="text" // ← KEY FIX
      value={value ?? ""}
      onChange={handle}
      inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
    />
  );
};

export const WeeklyStatsForm = ({
  data,
  setData,
  formErrors,
  setFormErrors,
}) => {
  const handleChange = (field, value) => {
    setData((prev) => ({ ...prev, [field]: value }));
    if (value && value.toString().trim() !== "") {
      setFormErrors((prev) => ({ ...prev, [field]: "" }));
    }
  };

  const labelStyle = {
    color: "var(--text-primary, #000000DE)",
    fontFamily: "Rethink Sans",
    fontSize: "0.875rem",
    lineHeight: "143%",
    letterSpacing: "0.17px",
    mb: 0.5,
  };

  const inputStyle = {
    fontFamily: "Rethink Sans",
    fontSize: "0.875rem",
    lineHeight: "143%",
    letterSpacing: "0.17px",
    "& .MuiOutlinedInput-root": {
      borderRadius: "8px",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderRadius: "8px",
    },
  };

  return (
    <Grid
      container
      columns={12}
      sx={{
        width: "100%",
        display: "grid",
        gridTemplateColumns: { xs: "1fr", sm: "1fr", md: "1fr 1fr" },
        gap: "16px",
        mt: "24px",
      }}
    >
      {/* Weekly patients */}
      <Grid item sx={{ width: "100%" }}>
        <Typography variant="body2" fontWeight={500} sx={labelStyle}>
          How many patients do you typically see each week?
        </Typography>

        <SafeNumberField
          fullWidth
          placeholder="250"
          value={data.weeklyPatients}
          onChange={(v) => handleChange("weeklyPatients", v)}
          error={!!formErrors.weeklyPatients}
          helperText={formErrors.weeklyPatients}
          size="small"
          sx={inputStyle}
        />
      </Grid>

      {/* New patients weekly */}
      <Grid item sx={{ width: "100%" }}>
        <Typography variant="body2" fontWeight={500} sx={labelStyle}>
          On average, how many are new patients each week?
        </Typography>

        <SafeNumberField
          fullWidth
          placeholder="20"
          value={data.averageWeeklyPatients}
          onChange={(v) => handleChange("averageWeeklyPatients", v)}
          error={!!formErrors.averageWeeklyPatients}
          helperText={formErrors.averageWeeklyPatients}
          size="small"
          sx={inputStyle}
        />
      </Grid>

      {/* Handleable weekly */}
      <Grid item sx={{ width: "100%" }}>
        <Typography variant="body2" fontWeight={500} sx={labelStyle}>
          At full capacity, how many patients could your team handle weekly?
        </Typography>

        <SafeNumberField
          fullWidth
          placeholder="350"
          value={data.handleablePatientsWeekly}
          onChange={(v) => handleChange("handleablePatientsWeekly", v)}
          error={!!formErrors.handleablePatientsWeekly}
          helperText={formErrors.handleablePatientsWeekly}
          size="small"
          sx={inputStyle}
        />
      </Grid>

      {/* Handleable new patients */}
      <Grid item sx={{ width: "100%" }}>
        <Typography variant="body2" fontWeight={500} sx={labelStyle}>
          At full capacity, what’s the most new patients you could take weekly?
        </Typography>

        <SafeNumberField
          fullWidth
          placeholder="30"
          value={data.handleableNewPatientsWeekly}
          onChange={(v) => handleChange("handleableNewPatientsWeekly", v)}
          error={!!formErrors.handleableNewPatientsWeekly}
          helperText={formErrors.handleableNewPatientsWeekly}
          size="small"
          sx={inputStyle}
        />
      </Grid>
    </Grid>
  );
};

export const TeamOverview = ({
  inputData,
  setInputData,
  formErrors,
  setFormErrors,
}) => {
  const peopleAtBusiness =
    inputData.peopleAtBusiness ?? inputData.peopleAtPractice ?? "";
  const peopleAtBusinessError =
    formErrors.peopleAtBusiness || formErrors.peopleAtPractice;
  const handleToggle = (field, value) => {
    setInputData((prev) => {
      if (prev[field] !== value) return { ...prev, [field]: value };
      return prev;
    });
    setFormErrors((prev) => ({ ...prev, [field]: "" }));
  };

  const handleChange = (field, value) => {
    setInputData((prev) => ({
      ...prev,
      [field]: value,
      ...(field === "peopleAtBusiness" ? { peopleAtPractice: value } : {}),
    }));
    setFormErrors((prev) => ({
      ...prev,
      [field]: "",
      ...(field === "peopleAtBusiness" ? { peopleAtPractice: "" } : {}),
    }));
  };

  const yesNoButtonStyles = (isSelected, position) => {
    const radius = 8;
    const borderColor = isSelected ? "#536DEC" : "rgba(0,0,0,0.23)";

    return {
      flex: 1,
      textTransform: "none",
      fontWeight: 500,
      color: isSelected ? "#536DEC" : "rgba(0,0,0,0.87)",
      backgroundColor: isSelected ? "#F5F7FF" : "#FFFFFF",
      border: `1px solid ${borderColor}`,
      borderTopLeftRadius: position === "left" ? radius : 0,
      borderBottomLeftRadius: position === "left" ? radius : 0,
      borderTopRightRadius: position === "right" ? radius : 0,
      borderBottomRightRadius: position === "right" ? radius : 0,
      marginRight: position === "left" ? "-1px" : 0,
      marginLeft: position === "right" ? "-1px" : 0,
      position: "relative",
      zIndex: isSelected ? 2 : 1,
      transition: "background-color 0.2s, color 0.2s, border-color 0.2s",
      "&:hover": { backgroundColor: "#F5F7FF" },
      "&:active": { backgroundColor: "#E5EBFF" },
    };
  };

  return (
    <Grid
      container
      columns={12}
      sx={{
        width: "100%",
        display: "grid",
        gridTemplateColumns: { xs: "1fr", sm: "1fr", md: "1fr 1fr" },
        gap: "16px",
        mt: "24px",
      }}
    >
      {/* Accepts Insurance */}
      <Grid sx={{ width: "100%" }}>
        <Typography variant="body2" fontWeight={500} mb={0.5}>
          Does your clinic accept insurance?
        </Typography>

        <Box sx={{ display: "flex", width: "100%" }}>
          <Button
            variant="text"
            onClick={() => handleToggle("acceptsInsurance", true)}
            sx={yesNoButtonStyles(inputData.acceptsInsurance === true, "left")}
          >
            Yes
          </Button>
          <Button
            variant="text"
            onClick={() => handleToggle("acceptsInsurance", false)}
            sx={yesNoButtonStyles(inputData.acceptsInsurance === false, "right")}
          >
            No
          </Button>
        </Box>

        {formErrors.acceptsInsurance && (
          <Typography variant="caption" color="error">
            {formErrors.acceptsInsurance}
          </Typography>
        )}
      </Grid>

      {/* Sees Patients */}
      <Grid sx={{ width: "100%" }}>
        <Typography variant="body2" fontWeight={500} mb={0.5}>
          Do you see patients yourself?
        </Typography>

        <Box sx={{ display: "flex", width: "100%" }}>
          <Button
            variant="text"
            onClick={() => handleToggle("seesPatientsInPerson", true)}
            sx={yesNoButtonStyles(
              inputData.seesPatientsInPerson === true,
              "left"
            )}
          >
            Yes
          </Button>
          <Button
            variant="text"
            onClick={() => handleToggle("seesPatientsInPerson", false)}
            sx={yesNoButtonStyles(
              inputData.seesPatientsInPerson === false,
              "right"
            )}
          >
            No
          </Button>
        </Box>

        {formErrors.seesPatientsInPerson && (
          <Typography variant="caption" color="error">
            {formErrors.seesPatientsInPerson}
          </Typography>
        )}
      </Grid>

      {/* People at business */}
      <Grid sx={{ width: "100%" }}>
        <Typography variant="body2" fontWeight={500} mb={0.5}>
          How many people work in your business?
        </Typography>

        <SafeNumberField
          fullWidth
          placeholder="10"
          value={peopleAtBusiness}
          onChange={(v) => handleChange("peopleAtBusiness", v)}
          error={!!peopleAtBusinessError}
          helperText={peopleAtBusinessError}
          size="small"
          sx={{ "& .MuiOutlinedInput-root": { borderRadius: "8px" } }}
        />
      </Grid>

      {/* Healthcare providers */}
      <Grid sx={{ width: "100%" }}>
        <Typography variant="body2" fontWeight={500} mb={0.5}>
          How many are healthcare providers?
        </Typography>

        <SafeNumberField
          fullWidth
          placeholder="3"
          value={inputData.healthCareProviders}
          onChange={(v) => handleChange("healthCareProviders", v)}
          error={!!formErrors.healthCareProviders}
          helperText={formErrors.healthCareProviders}
          size="small"
          sx={{ "& .MuiOutlinedInput-root": { borderRadius: "8px" } }}
        />
      </Grid>

      {/* Support/Admin staff */}
      <Grid sx={{ width: "100%" }}>
        <Typography variant="body2" fontWeight={500} mb={0.5}>
          How many are support or admin staff?
        </Typography>

        <SafeNumberField
          fullWidth
          placeholder="7"
          value={inputData.staff}
          onChange={(v) => handleChange("staff", v)}
          error={!!formErrors.staff}
          helperText={formErrors.staff}
          size="small"
          sx={{ "& .MuiOutlinedInput-root": { borderRadius: "8px" } }}
        />
      </Grid>
    </Grid>
  );
};

const MarketingEffortsForm = ({ data, setData }) => {
  const initialOther = (data.marketingFields || []).filter(
    (item) => !marketingOptions.includes(item)
  );

  const [selectedEfforts, setSelectedEfforts] = useState(
    data.marketingFields || []
  );
  const [showOtherField, setShowOtherField] = useState(initialOther.length > 0);
  const [customOther, setCustomOther] = useState(initialOther.join(", "));
  const [additionalInfo, setAdditionalInfo] = useState(
    data.addedBusinessContext ?? data.addedPracticeContext ?? ""
  );

  const handleCheckboxChange = (option) => {
    if (option === "Other") {
      setShowOtherField((prev) => !prev);
      if (showOtherField) {
        const filtered = selectedEfforts.filter((item) =>
          marketingOptions.includes(item)
        );
        setSelectedEfforts(filtered);
        setCustomOther("");
        setData((prev) => ({ ...prev, marketingFields: filtered }));
      }
      return;
    }

    const updatedEfforts = selectedEfforts.includes(option)
      ? selectedEfforts.filter((item) => item !== option)
      : [...selectedEfforts, option];

    setSelectedEfforts(updatedEfforts);
    setData((prev) => ({ ...prev, marketingFields: updatedEfforts }));
  };

  const handleCustomOtherChange = (e) => {
    const value = e.target.value;
    setCustomOther(value);

    const otherEntries = value
      .split(",")
      .map((v) => v.trim())
      .filter((v) => v !== "");

    const baseEfforts = selectedEfforts.filter((item) =>
      marketingOptions.includes(item)
    );
    const updatedEfforts = [...baseEfforts, ...otherEntries];

    setSelectedEfforts(updatedEfforts);
    setData((prev) => ({ ...prev, marketingFields: updatedEfforts }));
  };

  const handleAdditionalInfoChange = (e) => {
    const value = e.target.value;
    setAdditionalInfo(value);
    setData((prev) => ({
      ...prev,
      addedBusinessContext: value,
      addedPracticeContext: value,
    }));
  };

  return (
    <Box sx={{ width: "100%", mt: "24px" }}>
      <Typography
        variant="body1"
        fontWeight={500}
        sx={{ fontSize: "0.875rem" }}
      >
        Which marketing efforts are you actively using?
      </Typography>

      <FormGroup>
        <Box
          sx={{
            mt: "8px",
            display: "flex",
            flexWrap: { xs: "wrap", sm: "wrap", md: "nowrap" },
            gap: "12px",
          }}
        >
          {marketingOptions.map((option) => (
            <FormControlLabel
              key={option}
              control={
                <Checkbox
                  checked={
                    option === "Other"
                      ? showOtherField
                      : selectedEfforts.includes(option)
                  }
                  onChange={() => handleCheckboxChange(option)}
                  sx={{
                    color: "var(--action-active, #0000008F)",
                    "&.Mui-checked": { color: "var(--action-active, #536DEC)" },
                    "& .MuiSvgIcon-root": { borderRadius: "4px" },
                  }}
                />
              }
              label={option}
              sx={{
                "& .MuiFormControlLabel-label": {
                  fontFamily: "Rethink Sans",
                  fontWeight: "400",
                  fontSize: "0.875rem",
                  lineHeight: "143%",
                  letterSpacing: "0.17px",
                  wordBreak: "break-word",
                },
              }}
            />
          ))}
        </Box>
      </FormGroup>

      {showOtherField && (
        <Box>
          <Typography
            variant="body1"
            mt="12px"
            mb="4px"
            sx={{ fontSize: "0.875rem" }}
          >
            Other Marketing Efforts (comma-separated)
          </Typography>
          <TextField
            fullWidth
            size="small"
            variant="outlined"
            placeholder="Add other marketing channels… e.g., Flyers, Events, ..."
            value={customOther}
            onChange={handleCustomOtherChange}
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "8px",
              },
            }}
          />
        </Box>
      )}

      <Typography
        variant="body1"
        mt="18px"
        mb="4px"
        sx={{ fontSize: "0.875rem" }}
      >
        Additional Information (Optional)
      </Typography>
      <TextField
        multiline
        fullWidth
        minRows={3}
        placeholder="Describe any additional factors or context relevant to your business"
        variant="outlined"
        value={additionalInfo}
        onChange={handleAdditionalInfoChange}
        sx={{
          "& .MuiOutlinedInput-root": { borderRadius: "8px" },
        }}
      />
    </Box>
  );
};

export default MarketingEffortsForm;

export const ReviewPerformance = ({ inputData, setInputData }) => {
  const handleRemoveChip = (fieldToRemove) => {
    setInputData((prev) => ({
      ...prev,
      marketingFields: prev.marketingFields.filter(
        (field) => field !== fieldToRemove
      ),
    }));
  };

  const gridStyle = {
    display: "grid",
    gap: 2,
    gridTemplateColumns: {
      xs: "1fr",
      sm: "1fr",
      md: "1fr 1fr",
    },
  };

  return (
    <Box sx={{ width: "100%", mt: 2 }}>
      {/* Team Overview */}
      <Typography
        variant="subtitle1"
        mb={1}
        sx={{
          fontFamily: "Rethink Sans",
          fontWeight: 600,
          color: "var(--text-primary, #000000DE)",
        }}
      >
        Team Overview
      </Typography>

      <Box sx={{ ...gridStyle, mb: 3 }}>
        {[
          {
            label: "Does your clinic accept insurance?",
            value: inputData.acceptsInsurance ? "Yes" : "No",
          },
          {
            label: "Do you see patients yourself?",
            value: inputData.seesPatientsInPerson ? "Yes" : "No",
          },
          {
            label: "How many people work in your business?",
            value: inputData.peopleAtBusiness ?? inputData.peopleAtPractice,
          },
          {
            label: "How many are health care providers?",
            value: inputData.healthCareProviders,
          },
          {
            label: "How many are support or admin staff?",
            value: inputData.staff,
          },
        ].map((item, idx) => (
          <Box key={idx}>
            <Typography
              variant="body2"
              fontWeight={600}
              mb={0.5}
              sx={{
                fontFamily: "Rethink Sans",
                fontWeight: 600,
                fontSize: "0.875rem",
                lineHeight: "157%",
                letterSpacing: "0.1px",
                color: "var(--text-primary, #000000DE)",
              }}
            >
              {item.label}
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontFamily: "Rethink Sans",
              }}
            >
              {item.value}
            </Typography>
          </Box>
        ))}
      </Box>

      <Divider sx={{ my: 2 }} />

      {/* Capacity Overview */}
      <Typography
        variant="subtitle1"
        mb={1}
        sx={{
          fontFamily: "Rethink Sans",
          fontWeight: 600,
          color: "var(--text-primary, #000000DE)",
        }}
      >
        Capacity Overview
      </Typography>

      <Box sx={{ ...gridStyle, mb: 3 }}>
        {[
          {
            label: "How many patients do you typically see each week?",
            value: inputData.weeklyPatients,
          },
          {
            label: "On average, how many are new patients each week?",
            value: inputData.averageWeeklyPatients,
          },
          {
            label:
              "At full capacity, how many patients could your team handle weekly?",
            value: inputData.handleablePatientsWeekly,
          },
          {
            label:
              "At full capacity, what’s the most new patients you could take weekly?",
            value: inputData.handleableNewPatientsWeekly,
          },
        ].map((item, idx) => (
          <Box key={idx}>
            <Typography
              variant="body2"
              mb={0.5}
              sx={{
                fontFamily: "Rethink Sans",
                fontWeight: 600,
                fontSize: "0.875rem",
                lineHeight: "157%",
                letterSpacing: "0.1px",
                color: "var(--text-primary, #000000DE)",
              }}
            >
              {item.label}
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontFamily: "Rethink Sans",
              }}
            >
              {item.value}
            </Typography>
          </Box>
        ))}
      </Box>

      <Divider sx={{ my: 2 }} />

      {/* Performance Drivers */}
      <Typography
        variant="subtitle1"
        fontWeight={600}
        mb={1}
        sx={{
          fontFamily: "Rethink Sans",
          color: "var(--text-primary, #000000DE)",
        }}
      >
        Performance Drivers
      </Typography>

      {inputData.marketingFields?.length > 0 ||
      (inputData.addedBusinessContext ?? inputData.addedPracticeContext) ? (
        <Box sx={{ mb: 3 }}>
          {/* Marketing Fields as Chips */}
          {inputData.marketingFields?.length > 0 && (
            <>
              <Typography
                variant="body2"
                color="var(--text-primary, #000000DE)"
                fontWeight={600}
                mb={1}
                sx={{
                  fontFamily: "Rethink Sans",
                  fontWeight: 600,
                  fontSize: "0.875rem",
                  lineHeight: "157%",
                  letterSpacing: "0.1px",
                  color: "var(--text-primary, #000000DE)",
                }}
              >
                Which marketing efforts are you actively using?
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  flexWrap: "wrap", // wrap chips on mobile
                  gap: 1,
                }}
              >
                {inputData.marketingFields.map((field, idx) => (
                  <Chip
                    key={idx}
                    label={
                      !marketingOptions.includes(field)
                        ? `Other: ${field}`
                        : field
                    }
                    size="small"
                    onDelete={() => handleRemoveChip(field)}
                    deleteIcon={
                      <CancelIcon
                        sx={{
                          fontSize: 18,
                          color: "#666",
                          "&:hover": { color: "#000" },
                        }}
                      />
                    }
                    sx={{
                      "& .MuiChip-deleteIcon": { margin: "0 2px 0 -4px" },
                    }}
                  />
                ))}
              </Box>
            </>
          )}

          {/* Additional Business Context */}
          {(inputData.addedBusinessContext ?? inputData.addedPracticeContext) && (
            <Box sx={{ mt: 2 }}>
              <Typography
                variant="body2"
                fontWeight={600}
                mb={0.5}
                sx={{
                  fontFamily: "Rethink Sans",
                  fontWeight: 600,
                  fontSize: "0.875rem",
                  lineHeight: "157%",
                  letterSpacing: "0.1px",
                  color: "var(--text-primary, #000000DE)",
                }}
              >
                Additional Information
              </Typography>
              <Typography
                variant="body2"
                fontSize="1rem"
                sx={{
                  fontFamily: "Rethink Sans",
                }}
              >
                {inputData.addedBusinessContext ?? inputData.addedPracticeContext}
              </Typography>
            </Box>
          )}
        </Box>
      ) : (
        <Typography
          variant="body1"
          mb={3}
          sx={{
            fontFamily: "Rethink Sans",
            fontWeight: 600,
            fontSize: "0.875rem",
            lineHeight: "157%",
            letterSpacing: "0.1px",
            color: "var(--text-primary, #000000DE)",
          }}
        >
          No performance drivers provided.
        </Typography>
      )}
    </Box>
  );
};
